import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { createContentSelector } from '../selectors/selectors';

function useTemplateFormData() {
  const {
    contentElements,
    subject,
    formMode,
    templateName,
    createStatus,
    editStatus,
    deleteStatus,
  } = useSelector(createContentSelector);

  const isValid = !isEmpty(contentElements) && !isEmpty(subject);

  return {
    isValid,
    formMode,
    templateName,
    createStatus,
    editStatus,
    deleteStatus,
  };
}

export default useTemplateFormData;
